export default {"src":"/_next/static/media/close.581f3369.svg","height":13,"width":13,"blurWidth":0,"blurHeight":0};